/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import SpinnerOverlay from '@tcp/core/src/components/common/atoms/SpinnerOverlay';
import GhostOverlay from '@tcp/core/src/components/common/atoms/GhostOverlay';
import { MULTI_PACK_TYPE } from '@tcp/core/src/components/common/molecules/ProductAddToBag/container/ProductAddToBag.config';
import { currencyConversion } from '@tcp/core/src/components/features/CnC/CartItemTile/utils/utils';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import { capitalizeWords, getIconPath } from '@tcp/core/src/utils/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel/container';
import { getViewportInfo, getImageFilePath, isClient, getImageData } from '@tcp/core/src/utils';
import dyRecommendationTitle from '@tcp/core/src/services/abstractors/common/recommendations/utils/dyUtils.js';
import { getATBContext } from '@tcp/core/src/services/abstractors/common/recommendations/utils/dyRequestContext.js';
import {
  dyPageNames,
  dySelectors,
} from '@tcp/core/src/services/abstractors/common/recommendations/utils/constants.js';
import AddedToBagActions from '../../AddedToBagActions';
import AddedToBagViewPoints from '../../AddedToBagViewPoints';
import Modal from '../../../../common/molecules/Modal';
import withStyles from '../../../../common/hoc/withStyles';
import {
  EINSTEIN_RECOMMENDATION_STRATEGIES,
  RECOMMENDATION_ENGINES,
} from '../../../../common/molecules/AiRecommendations/container/AiRecommendations.constants';
import styles, {
  modalStyles,
  productInfoStyles,
  pointsInfoStyles,
  buttonActionStyles,
  LoyaltyWrapperStyles,
  recommendationStyles,
  customStyles,
} from '../styles/AddedToBag.style';
import ProductInformationRedesign from '../molecules/ProductInformation/views/ProductInformationRedesign.views';
import BossBannerView from '../molecules/BossBanner/views/BossBanner.views';
import PickupBannerView from '../molecules/PickupBanner/views/PickupBanner.view';
import LoyaltyBanner from '../../LoyaltyBanner';
import PlacePerkBanner from '../../PlacePerkBanner';
import config from './config';
import { getPartNumber, getOfferPrice, getVariantID } from './AddedToBag.utils';
import ErrorMessage from '../../common/molecules/ErrorMessage';
import { PAGE_VARIANTS } from '../../PlacePerkBanner/PlacePerkConstants';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import {
  GlobalAddToBagLabels,
  GLOBAL_ADD_TO_BAG_MODAL_LABELS,
} from '../../../../../utils/labels/globalAddedToBag.labels';
import {
  GlobalAccessibilityLabels,
  GLOBAL_ACCESSIBILITY_LABELS,
} from '../../../../../utils/labels/globalAccessibility.labels';
import BAGPAGE_CONSTANTS from '../../BagPage/BagPage.constants';
import FreeShippingProgressBar from '../../common/organism/FreeShippingProgressBar';
import DamImage from '../../../../common/atoms/DamImage';
import GlobalErrorComponentContainer from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.container';
import {
  GLOBAL_RECOMMENDATIONS,
  lblHomepageYouMayAlsoLike,
  RecommendationLabels,
} from '../../../../common/molecules/Recommendations/container/Recommendations.labels';

const BundleTrackerContainer = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "bundle-tracker-container" */ '@tcp/core/src/components/common/atoms/BundleTracker/container/BundleTracker.container'
    ),
  { ssr: false }
);

const Recommendations = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "recommendations" */ '@tcp/core/src/components/common/molecules/Recommendations'
  )
);

const AiRecommendations = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "ai-recommendations" */ '@tcp/core/src/components/common/molecules/AiRecommendations/container/AiRecommendations.container'
    ),
  {
    ssr: false,
  }
);

const DyRecommendations = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "dy-recommendations" */
      '@tcp/core/src/components/common/molecules/DyRecommendations/container/DyRecommendations.container'
    ),
  {
    ssr: true,
  }
);

const ProductInformationView = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "ProductInformationView" */ '../molecules/ProductInformation/views/ProductInformation.views'
  )
);

const getIsExpanded = (isExpanded) => (isExpanded ? 'expanded' : 'collapsed');
const shouldRenderPointsView = (
  pointsSummary,
  isATBHidePoints,
  isOptimisticModalWithError,
  isOptmisticAddToBagModal,
  isLoyaltyPointsEnabled
) => {
  if (isOptimisticModalWithError || !isLoyaltyPointsEnabled) {
    return false;
  }
  if (isOptmisticAddToBagModal) {
    return !isATBHidePoints;
  }
  return Object.keys(pointsSummary).length !== 0 && !isATBHidePoints;
};

const getNewArr = (atbUnavailableProducts) => {
  if (atbUnavailableProducts) {
    return atbUnavailableProducts?.products?.map((item) => ({
      imageUrl: item.skuInfo.imageUrl,
      unbxdProdId: item.skuInfo.unbxdProdId,
      variantId: item.skuInfo.variantId,
    }));
  }
  return [];
};

const getError = (atbUnavailableProducts) => {
  const { error } = atbUnavailableProducts || {};
  return error;
};

const getGlobalErrorMessageCopy = (
  isInventoryUnavailable,
  newGlobalErrorMessageEnabled,
  addToPickupError,
  errMsg,
  error
) => {
  return isInventoryUnavailable && newGlobalErrorMessageEnabled
    ? addToPickupError || errMsg
    : getDynamicLabelValues(`dynamic.cart.lbl_atb_error${error?.errorCode}`);
};

const getErrorMessageClassName = (
  isInventoryUnavailable,
  newGlobalErrorMessageEnabled,
  isExpanded
) => {
  return isInventoryUnavailable && newGlobalErrorMessageEnabled
    ? `error-subheader-container ${getIsExpanded(isExpanded)}`
    : 'error-subheader';
};

const getIsShowErrorMessage = (
  error,
  showInventoryUnavailableMessage,
  newGlobalErrorMessageEnabled
) => {
  return error || (showInventoryUnavailableMessage && newGlobalErrorMessageEnabled);
};

const getShowInvUnavailableMsg = (isInventoryUnavailable, addToPickupError, errMsg) => {
  return isInventoryUnavailable && (addToPickupError || errMsg);
};

const getIsOptimisticModalWithError = (
  isOptmisticAddToBagModal,
  addedToBagError,
  errMsg,
  addToPickupError,
  newGlobalErrorMessageEnabled
) =>
  isOptmisticAddToBagModal &&
  (addedToBagError || errMsg || addToPickupError) &&
  !newGlobalErrorMessageEnabled;

const getIsNewErrorDesign = (
  addedToBagError,
  errMsg,
  addToPickupError,
  newGlobalErrorMessageEnabled,
  isInventoryUnavailable
) => {
  return (
    (addedToBagError || errMsg || addToPickupError) &&
    newGlobalErrorMessageEnabled &&
    !isInventoryUnavailable
  );
};
class AddedToBag extends React.PureComponent {
  addedToBagLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_TO_BAG_MODAL_LABELS,
    GlobalAddToBagLabels
  );

  accessibilityLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ACCESSIBILITY_LABELS,
    GlobalAccessibilityLabels
  );

  constructor(props) {
    super(props);
    this.state = {
      activeSlide: 0,
      isExpanded: true,
    };

    const { isQvModalOpen, isBackToQuickviewCTAEnabled } = props;

    if (isQvModalOpen && isBackToQuickviewCTAEnabled) {
      this.hideQuickViewModal();
    }
  }

  /* eslint-disable-next-line */
  UNSAFE_componentWillReceiveProps({ router: nextRouter }) {
    const { router, closeModal } = this.props;
    /* istanbul ignore else */
    if (router && nextRouter && router.asPath !== nextRouter.asPath) {
      closeModal();
    }
  }

  componentDidMount() {
    const {
      addedToBagData,
      userDefaultStore,
      getFavoriteStore,
      showBOPISPickupInstead,
      isQvModalOpen,
      closeQvModal,
      isBackToQuickviewCTAEnabled,
    } = this.props;
    const { pickupType } = addedToBagData || {};
    if (isQvModalOpen && !isBackToQuickviewCTAEnabled) {
      closeQvModal();
    }
    if (showBOPISPickupInstead && !pickupType && !userDefaultStore?.basicInfo) {
      const latLong = readCookie('tcpGeoLoc');
      if (latLong) {
        const [lat, long] = latLong.split('|');
        getFavoriteStore({ geoLatLang: { lat, long }, isForceUpdate: true });
      }
    }
  }

  componentWillUnmount() {
    const { clearSelectedAccessories } = this.props;
    clearSelectedAccessories();
  }

  getmultipackProductType = () => {
    const { addedToBagData, isABTestOffStyleWith, isPhysicalMpackEnabled } = this.props;
    const TCPStyleType =
      addedToBagData && addedToBagData.skuInfo && addedToBagData.skuInfo.TCPStyleType;
    return (
      isPhysicalMpackEnabled && TCPStyleType === MULTI_PACK_TYPE.MULTIPACK && !isABTestOffStyleWith
    );
  };

  hideQuickViewModal = () => {
    if (isClient()) {
      const quickViewModalContentWrapper = document.querySelector(
        '.quick-view-modal-content-wrapper'
      );
      const quickViewModalOverlay = document.querySelector('.quick-view-modal-overlay');

      if (quickViewModalContentWrapper) {
        quickViewModalContentWrapper.classList.add('hide-qv-content');
      }
      if (quickViewModalOverlay) {
        quickViewModalOverlay.classList.add('hide-overlay');
      }
    }
  };

  getVariations = () => {
    const ismultipackProductType = this.getmultipackProductType();
    return ismultipackProductType ? 'styleWith' : 'moduleO';
  };

  getHeaderLabel = () => {
    const ismultipackProductType = this.getmultipackProductType();
    return ismultipackProductType
      ? renderLabel(this.addedToBagLabels?.lbl_heading_styleWith, 'lbl_heading_styleWith')
      : null;
  };

  getPortalValue = () => {
    const ismultipackProductType = this.getmultipackProductType();
    return ismultipackProductType ? Constants.RECOMMENDATIONS_MBOXNAMES.STYLE_WITH : '';
  };

  getStyleWrapperClass = () => {
    const ismultipackProductType = this.getmultipackProductType();
    return ismultipackProductType ? 'style-with-wrapper' : '';
  };

  getFbtWrapperClass = (isFbtCompleted) => {
    return isFbtCompleted ? 'fbt-complete' : '';
  };

  renderGhostOverlay = (
    addedToBagGhostLoaderState,
    addedToBagGhostLoaderCompleteState,
    isFBTDisplayed
  ) => {
    return (
      addedToBagGhostLoaderState &&
      !isFBTDisplayed && (
        <GhostOverlay loadingMsg="ADDED TO BAG" isComplete={addedToBagGhostLoaderCompleteState} />
      )
    );
  };

  renderSpinnerOverlay = (addedToBagLoaderState) => {
    return addedToBagLoaderState && <SpinnerOverlay inheritedStyles={customStyles} />;
  };

  getPartNumber = (addedToBagData) => {
    return addedToBagData && addedToBagData.skuInfo && addedToBagData.skuInfo.productId;
  };

  getModalHeading = (isOptimisticModalWithError) => {
    let modalHeading = isOptimisticModalWithError
      ? ''
      : renderLabel(this.addedToBagLabels?.lbl_header_addedToBag, 'lbl_header_addedToBag');

    modalHeading = capitalizeWords(modalHeading);

    return modalHeading;
  };

  calculateItemPrice = (itemPrice, offerPrice, isOptmisticAddToBagModal) => {
    return isOptmisticAddToBagModal ? itemPrice || offerPrice : itemPrice;
  };

  getModifiedString = (totalItems) => {
    const totalItemsText = totalItems !== 0 ? totalItems : '';

    const subHeading = `<span>${renderLabel(
      this.addedToBagLabels?.lbl_bag_sub_total_addtobagredesign,
      'lbl_bag_sub_total_addtobagredesign'
    )?.replace('_itemscount_', totalItemsText)}</span>`;
    return (
      // eslint-disable-next-line react/no-danger
      <span dangerouslySetInnerHTML={{ __html: subHeading }} />
    );
  };

  renderProductInfo() {
    const {
      addedToBagData,
      quantity,
      pointsSummary,
      bagLoading,
      isSuppressGetOrderDetails,
      isInternationalShipping,
      isAvoidGetOrderDetails,
      isATBHidePoints,
      isATBModalBackAbTestNewDesign,
      primaryBrand,
      alternateBrand,
      isLoyaltyPointsEnabled,
    } = this.props;
    if (Array.isArray(addedToBagData)) {
      const hasDoubleItems = addedToBagData.length > 1;
      return addedToBagData.map((item) => {
        const prodData = {
          ...item,
          imgConfig: ['t_t_atb_m', 't_t_atb_t', 't_t_atb_d'],
        };
        const { itemPrice } = item;
        return (
          <div className="elem-mb-SM" key={itemPrice}>
            <ProductInformationView
              data={prodData}
              inheritedStyles={productInfoStyles}
              isDoubleAddedToBag
              hasDoubleItems={hasDoubleItems}
              bagLoading={bagLoading}
              isSuppressGetOrderDetails={isSuppressGetOrderDetails}
              isInternationalShipping={isInternationalShipping}
              isAvoidGetOrderDetails={isAvoidGetOrderDetails}
              isATBHidePoints={isATBHidePoints}
              isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
              primaryBrand={primaryBrand}
              alternateBrand={alternateBrand}
              isLoyaltyPointsEnabled={isLoyaltyPointsEnabled}
            />
          </div>
        );
      });
    }
    const prodData = {
      ...addedToBagData,
      imgConfig: ['t_t_atb_m', 't_t_atb_t', 't_t_atb_d'],
    };
    return (
      <ProductInformationView
        data={{ ...prodData, ...pointsSummary }}
        quantity={quantity}
        inheritedStyles={productInfoStyles}
        isAvoidGetOrderDetails={isAvoidGetOrderDetails}
        isATBHidePoints={isATBHidePoints}
        isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
        primaryBrand={primaryBrand}
        alternateBrand={alternateBrand}
        isLoyaltyPointsEnabled={isLoyaltyPointsEnabled}
      />
    );
  }

  shouldRenderPickUpBanner = (pickupType, isOnlineExclusive) => {
    return !pickupType && !isOnlineExclusive;
  };

  getIsCarousel = (addedToBagData) => {
    if (!Object.keys(addedToBagData?.[addedToBagData.length - 1])?.length) {
      return addedToBagData?.length - 1 > 1;
    }
    return addedToBagData?.length > 1;
  };

  getPrevArrow = (addedToBagData, activeSlide) => {
    if (addedToBagData.length > 1 && activeSlide > 0) {
      return (
        <button
          type="button"
          aria-label={renderLabel(this.accessibilityLabels?.previousButton, 'previousButton')}
        >
          <Image src={`${getImageFilePath()}/Icon_Next.svg`} alt="previous" />
        </button>
      );
    }
    return <></>;
  };

  isShownNextButton = (addedToBagData, activeSlide) => {
    if (addedToBagData.length > 1 && activeSlide + 1 < addedToBagData.length) {
      return true;
    }
    return false;
  };

  getNextArrow = (addedToBagData, activeSlide) => {
    if (this.isShownNextButton(addedToBagData, activeSlide)) {
      return (
        <button
          type="button"
          aria-label={renderLabel(this.accessibilityLabels?.nextIconButton, 'nextIconButton')}
        >
          <Image src={`${getImageFilePath()}/Icon_Next.svg`} alt="next" />
        </button>
      );
    }
    return <></>;
  };

  getAddedToBagAfterTrimming = () => {
    const { addedToBagData } = this.props;
    const len = addedToBagData.length;
    if (!Object.keys(addedToBagData[len - 1]).length) {
      return addedToBagData.pop();
    }
    return addedToBagData;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  renderProductInfoNew(displayPrice) {
    const {
      addedToBagData,
      quantity,
      pointsSummary,
      bagLoading,
      isSuppressGetOrderDetails,
      isInternationalShipping,
      isAvoidGetOrderDetails,
      isATBHidePoints,
      isATBModalBackAbTestNewDesign,
      primaryBrand,
      alternateBrand,
      isPlcc,
      loyaltyOrderItems,
      isOffersDisplayEnabled,
      currencyAttributes,
      isLoyaltyPointsEnabled,
      itemInfo,
      isUserPersonalizationEnabled,
      isUserPersonalizationApiEnabled,
      saveUserPreferences,
      router,
      isHardcodeSizeMapEnabled,
      hardcodeSizeMapConfig,
      isNewATBProductInformationDesignEnabled,
      offerPriceIsLoading,
      atbUnavailableProducts,
      isOptmisticAddToBagModal,
      loyaltyOrderItemPoints,
      isLoyaltyTieringEnabled,
    } = this.props;
    const { totalItems, bagSubTotal } = pointsSummary;

    const isFromPjPlanner = addedToBagData?.length > 0 && addedToBagData[0].isFromPjPlanner;
    let atbUnavailableProductsArray = [];
    const productIdsString = atbUnavailableProducts?.error?.errorParameters?.PRODUCT_IDS;
    atbUnavailableProductsArray = productIdsString && productIdsString.split('|');
    let addedToBagDataArray = addedToBagData;
    if (
      isFromPjPlanner &&
      atbUnavailableProductsArray?.length > 0 &&
      addedToBagData?.length === 2 &&
      isOptmisticAddToBagModal
    )
      addedToBagDataArray = addedToBagData?.filter((item) => {
        return !atbUnavailableProductsArray.includes(item?.skuInfo?.variantId);
      });
    if (Array.isArray(addedToBagDataArray) && addedToBagDataArray.length > 1) {
      const { activeSlide } = this.state;

      const hasDoubleItems = addedToBagDataArray.length > 1;
      const CAROUSEL_OPTIONS = {
        autoplay: false,
        arrows: true,
        autoplaySpeed: 4000,
        infinite: false,
        initialSlide: 0,
        fade: false,
        speed: 1000,
        dots: false,
        dotsClass: 'slick-dots',
        focusOnSelect: true,
        swipe: true,
        slidesToShow: 1.3,
        responsive: [
          {
            settings: {
              arrows: true,
            },
          },
        ],
      };
      const isMobile = isClient() ? getViewportInfo().isMobile : null;
      const isCarousel = this.getIsCarousel(addedToBagDataArray);
      const renderCarousel = () => {
        return addedToBagDataArray.map((item) => {
          const prodData = {
            ...item,
            imgConfig: ['t_t_atb_m', 't_t_atb_t', 't_t_atb_d'],
          };
          const { itemPrice } = item;
          if (
            !prodData?.skuInfo ||
            (atbUnavailableProductsArray?.includes(prodData?.skuInfo?.variantId) &&
              isOptmisticAddToBagModal &&
              isFromPjPlanner)
          ) {
            return null;
          }
          return (
            <div className="elem-mb-SM tile-equal-height smooth-scroll-list-item" key={itemPrice}>
              <ProductInformationRedesign
                quantity={quantity}
                data={prodData}
                inheritedStyles={productInfoStyles}
                isDoubleAddedToBag
                hasDoubleItems={hasDoubleItems}
                bagLoading={bagLoading}
                isSuppressGetOrderDetails={isSuppressGetOrderDetails}
                isInternationalShipping={isInternationalShipping}
                isAvoidGetOrderDetails={isAvoidGetOrderDetails}
                isATBHidePoints={isATBHidePoints}
                isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
                primaryBrand={primaryBrand}
                alternateBrand={alternateBrand}
                displayPrice={displayPrice}
                isPlcc={isPlcc}
                loyaltyOrderItems={loyaltyOrderItems}
                isOffersDisplayEnabled={isOffersDisplayEnabled}
                currencyAttributes={currencyAttributes}
                isLoyaltyPointsEnabled={isLoyaltyPointsEnabled}
                itemInfo={itemInfo}
                isCarouselIncluded
                isUserPersonalizationEnabled={isUserPersonalizationEnabled}
                isUserPersonalizationApiEnabled={isUserPersonalizationApiEnabled}
                saveUserPreferences={saveUserPreferences}
                router={router}
                isHardcodeSizeMapEnabled={isHardcodeSizeMapEnabled}
                hardcodeSizeMapConfig={hardcodeSizeMapConfig}
                subTotalComponent={this.getModifiedString(totalItems || 0)}
                bagSubTotal={bagSubTotal}
                isNewATBProductInformationDesignEnabled={isNewATBProductInformationDesignEnabled}
                offerPriceIsLoading={offerPriceIsLoading}
                loyaltyOrderItemPoints={loyaltyOrderItemPoints}
                isLoyaltyTieringEnabled={isLoyaltyTieringEnabled}
              />
            </div>
          );
        });
      };
      return isMobile ? (
        <div className="smooth-scroll-list">{renderCarousel()}</div>
      ) : (
        <Carousel
          className={isCarousel ? 'added-to-bag-multi-item' : 'added-to-bag-multi-item-style'}
          options={{
            ...CAROUSEL_OPTIONS,
            prevArrow: this.getPrevArrow(this.getAddedToBagAfterTrimming(), activeSlide),
            nextArrow: this.getNextArrow(this.getAddedToBagAfterTrimming(), activeSlide),
            afterChange: (current) => this.setState({ activeSlide: current }),
          }}
          carouselConfig={{
            customArrowLeft: null,
            customArrowRight: null,
            type: 'dark',
          }}
        >
          {renderCarousel()}
        </Carousel>
      );
    }
    let prodData = {
      ...addedToBagDataArray,
      imgConfig: ['t_t_atb_m', 't_t_atb_t', 't_t_atb_d'],
    };
    if (Array.isArray(addedToBagDataArray) && addedToBagDataArray.length === 1) {
      prodData = {
        ...addedToBagDataArray[0],
        imgConfig: ['t_t_atb_m', 't_t_atb_t', 't_t_atb_d'],
      };
    }
    if (addedToBagDataArray?.length === 1 || addedToBagDataArray?.skuInfo) {
      return (
        <ProductInformationRedesign
          data={{ ...prodData, ...pointsSummary }}
          quantity={quantity}
          isAvoidGetOrderDetails={isAvoidGetOrderDetails}
          isATBHidePoints={isATBHidePoints}
          isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
          primaryBrand={primaryBrand}
          alternateBrand={alternateBrand}
          displayPrice={displayPrice}
          isPlcc={isPlcc}
          loyaltyOrderItems={loyaltyOrderItems}
          isOffersDisplayEnabled={isOffersDisplayEnabled}
          currencyAttributes={currencyAttributes}
          isLoyaltyPointsEnabled={isLoyaltyPointsEnabled}
          itemInfo={itemInfo}
          isUserPersonalizationEnabled={isUserPersonalizationEnabled}
          isUserPersonalizationApiEnabled={isUserPersonalizationApiEnabled}
          saveUserPreferences={saveUserPreferences}
          router={router}
          isHardcodeSizeMapEnabled={isHardcodeSizeMapEnabled}
          hardcodeSizeMapConfig={hardcodeSizeMapConfig}
          subTotalComponent={this.getModifiedString(totalItems || 0)}
          bagSubTotal={bagSubTotal}
          isNewATBProductInformationDesignEnabled={isNewATBProductInformationDesignEnabled}
          offerPriceIsLoading={offerPriceIsLoading}
          loyaltyOrderItemPoints={loyaltyOrderItemPoints}
          isLoyaltyTieringEnabled={isLoyaltyTieringEnabled}
        />
      );
    }
    return <></>;
  }

  /* eslint-disable */
  renderPickupBanner() {
    const {
      addedToBagData,
      getBopisInventoryDetails,
      userDefaultStore,
      bopisItemInventory,
      addItemToCartInPickup,
      addToPickupError,
      setAddToPickupError,
      showBOPISPickupInstead,
      pageType,
      isATBModalBackAbTestNewDesign,
      alternateBrand,
      renderPickupBanner,
      isFBTDisplayed,
      isAddedToBagRedesignEnabled,
    } = this.props;
    const { pickupType, isOnlineExclusive, isBopisOrder } = addedToBagData;
    return showBOPISPickupInstead &&
      !isBopisOrder &&
      !pickupType &&
      !renderPickupBanner &&
      !isOnlineExclusive &&
      !isFBTDisplayed ? (
      // eslint-disable-next-line react/jsx-indent
      <PickupBannerView
        addedToBagData={addedToBagData}
        getBopisInventoryDetails={getBopisInventoryDetails}
        pageType={pageType}
        userDefaultStore={userDefaultStore}
        bopisItemInventory={bopisItemInventory}
        addItemToCartInPickup={addItemToCartInPickup}
        addToPickupError={addToPickupError}
        setAddToPickupError={setAddToPickupError}
        isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
        alternateBrand={alternateBrand}
        isAddedToBagRedesign={isAddedToBagRedesignEnabled}
      />
    ) : null;
  }

  renderBossBanner = () => {
    const {
      isInternationalShipping,
      isBossEnabled,
      isFBTDisplayed,
      isAddedToBagRedesignEnabled,
      addedToBagData,
    } = this.props;
    const { isBoss } = addedToBagData || {};
    return (
      !isBoss &&
      !isInternationalShipping &&
      isBossEnabled &&
      !isFBTDisplayed && <BossBannerView isAddedToBagRedesign={isAddedToBagRedesignEnabled} />
    );
  };

  getFbtClass = (isFBTDisplayed) => (isFBTDisplayed ? 'fbt-wrapper' : '');

  getRecommClass = (isNewAtb) => (isNewAtb ? 'recommendation-caro' : '');

  getBluredClass = () => {
    const { addedToBagGhostLoaderState, isFBTDisplayed } = this.props;
    return addedToBagGhostLoaderState && !isFBTDisplayed ? 'blurred-content' : '';
  };

  getATBModalBackABClassClass = () => {
    return 'new-added-to-bag-modal';
  };

  getATBRedesignContent = (displayPrice, totalItems, bagSubTotal) => {
    const {
      isATBHidePoints,
      isATBModalBackAbTestNewDesign,
      isOptmisticAddToBagModal,
      itemInfo,
      currencyAttributes,
      isUserLoggedIn,
      isPlacePerkEnabled,
      isNewATBProductInformationDesignEnabled,
      addToBagMultipleItemError,
      addedToBagError,
      addedToBagData,
    } = this.props;
    const totalItemsInBag =
      itemInfo &&
      itemInfo.orderItems &&
      itemInfo.orderItems.reduce((sum, item) => {
        return sum + parseInt(item.itemInfo.quantity, 10);
      }, 0);
    const pageVariant = PAGE_VARIANTS.ADDED_TO_BAG_PAGE;
    const { errMsg } = addToBagMultipleItemError;
    const isFromPjPlanner =
      (addedToBagData?.length > 0 && addedToBagData[0].isFromPjPlanner) ||
      addedToBagData?.isFromPjPlanner;
    const allItemUnavailableError =
      isFromPjPlanner && isOptmisticAddToBagModal && (errMsg || addedToBagError);
    if (allItemUnavailableError) {
      return null;
    }
    return (
      <div className="newAddtobag-wrapper">
        {this.renderProductInfoNew(displayPrice)}
        {!!bagSubTotal && !isNewATBProductInformationDesignEnabled && (
          <div className="margin-none sub-total">
            <div className="full-bleed">
              <BodyCopy
                tag="span"
                fontSize="fs14"
                fontWeight="bold"
                textAlign="left"
                className="sub-total"
                dataLocator="addedtobag-productname"
                fontFamily="secondary"
              >
                {this.getModifiedString(totalItems || 0)}
              </BodyCopy>
            </div>
            <div
              data-locator="addedtobag-bagsubtotal"
              className={`text-value added-to-bag-subtotal`}
              colSize={{ large: 1, small: 1, medium: 1 }}
            >
              <BodyCopy
                tag="span"
                textAlign="right"
                className="product-price margin-none"
                dataLocator="addedtobag-productprice"
                fontFamily="secondary"
              >
                {bagSubTotal ? (
                  <PriceCurrency price={currencyConversion(bagSubTotal, currencyAttributes)} />
                ) : (
                  '-'
                )}
              </BodyCopy>
            </div>
          </div>
        )}
        <div className="loyaltyAddedToBagWrapper">
          <LoyaltyBanner
            pageCategory="isAddedToBagPage"
            inheritedStyles={LoyaltyWrapperStyles}
            isOptmisticAddToBagModal={isOptmisticAddToBagModal}
            isAddedToBagRedesign
          />
        </div>
        {isUserLoggedIn && isPlacePerkEnabled && <PlacePerkBanner pageVariant={pageVariant} />}
      </div>
    );
  };

  renderProductDetails = (displayPrice, totalItems, bagSubTotal, isOptimisticModalWithError) => {
    const { isAddedToBagRedesignEnabled } = this.props;
    return isAddedToBagRedesignEnabled
      ? this.getATBRedesignContent(
          displayPrice,
          totalItems,
          bagSubTotal,
          isOptimisticModalWithError
        )
      : this.renderProductInfo();
  };

  getHideClass = () => {
    const { isAddedToBagRedesignEnabled } = this.props;
    return isAddedToBagRedesignEnabled ? 'is-hidden' : '';
  };

  getFreeShippingProgressBar = ({
    shipments,
    freeShippingThreshold,
    productTotal,
    dynamicShippingCharge,
    isBossEnabled,
    shippingMethodSelected,
    isMixedOrder,
    isFreeShippingProgressBarDisabled,
    isShippingOrder,
    isFreeShippingCouponApplied,
    freeShippingMessageForPromosEnabled,
    freeShippingPromoType,
  }) => {
    const shipmentsObject = shipments && JSON.parse(JSON.stringify(shipments));
    const shippingDetails = shipmentsObject?.filter(
      (shipment) => shipment?.c_fromStoreId === null
    )[0];

    const shippingMethodCodeSelected =
      shippingMethodSelected?.code || shippingDetails?.shippingMethod?.c_code;
    const shippingFreePercentage = (shippingDetails?.productTotal / freeShippingThreshold) * 100;
    const isShippingMethodApplicableForFreeShipping =
      BAGPAGE_CONSTANTS.FREE_SHIPMENT_CODES?.includes(shippingMethodCodeSelected);
    const showFreeShippingProgressBar =
      isShippingMethodApplicableForFreeShipping &&
      isShippingOrder &&
      !isFreeShippingProgressBarDisabled;
    return (
      showFreeShippingProgressBar &&
      freeShippingThreshold > 0 && (
        <FreeShippingProgressBar
          shipments={shipmentsObject}
          freeShippingThreshold={freeShippingThreshold}
          productTotal={productTotal}
          dynamicShippingCharge={dynamicShippingCharge}
          isBossEnabled={isBossEnabled}
          shippingFreePercentage={shippingFreePercentage}
          isMixedOrder={isMixedOrder}
          isFreeShippingCouponApplied={isFreeShippingCouponApplied}
          freeShippingPromoType={freeShippingPromoType}
          freeShippingMessageForPromosEnabled={freeShippingMessageForPromosEnabled}
          fromATBDrawer
        />
      )
    );
  };

  getToggleImage = () => {
    const { isExpanded } = this.state;

    return isExpanded ? (
      <Image src={getIconPath('down_arrow_icon')} alt="down_arrow_icon" />
    ) : (
      <Image src={getIconPath('up_arrow_icon')} alt="up_arrow_icon" />
    );
  };

  toggleExpand = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }));
  };

  renderErrorMessage = (isOptimisticModalWithError, isNewErrorDesign, errMsg) => {
    const { newGlobalErrorMessageEnabled, addedToBagError, addToPickupError } = this.props;
    return isOptimisticModalWithError || isNewErrorDesign ? (
      <div>
        {!newGlobalErrorMessageEnabled ? (
          <ErrorMessage
            isAddedToBag
            className="error-notification elem-mt-MED"
            error={addedToBagError || addToPickupError || errMsg}
            fontSize="fs14"
            fontWeight="extrabold"
            spc
          />
        ) : (
          <GlobalErrorComponentContainer
            fromCartAndCheckoutPageError
            isMiniError
            fromAtbError
            errorMsg={addedToBagError || addToPickupError || errMsg}
            hideClose
          />
        )}
      </div>
    ) : null;
  };

  render() {
    const {
      openState,
      onRequestClose,
      className,
      handleContinueShopping,
      handleCartCheckout,
      hideHeader,
      addedToBagLoaderState,
      addedToBagData,
      pointsSummary,
      enableKeepShoppingCTA,
      addedToBagGhostLoaderState,
      addedToBagGhostLoaderCompleteState,
      isATBHidePoints,
      addedToBagError,
      isOptmisticAddToBagModal,
      addToPickupError,
      isATBModalBackAbTestNewDesign,
      isFBTEnabled,
      isFBTDisplayed,
      isFbtCompleted,
      isAddedToBagRedesignEnabled,
      addToBagMultipleItemError,
      isLoyaltyPointsEnabled,
      isBundleTrackerEnabled,
      isSyteEnabled,
      userId,
      shipments,
      freeShippingThreshold,
      productTotal,
      dynamicShippingCharge,
      isBossEnabled,
      shippingMethodSelected,
      isMixedOrder,
      isFreeShippingProgressBarDisabled,
      isShippingOrder,
      isFreeShippingCouponApplied,
      isNewATBProductInformationDesignEnabled,
      freeShippingMessageForPromosEnabled,
      freeShippingPromoType,
      isBackToQuickviewCTAEnabled,
      isQvModalOpen,
      atbUnavailableProducts,
      newGlobalErrorMessageEnabled,
      isInventoryUnavailable,
      loyaltyOrderItemPoints,
      isLoyaltyTieringEnabled,
      serverTime,
      loadDyRecommendations,
      isDyEnabled,
      atb1Rec,
    } = this.props;
    const partNumber = getPartNumber(addedToBagData);
    const variantId = getVariantID(addedToBagData);
    const carouselProps = {
      ...config.CAROUSEL_OPTIONS,
      touchThreshold: 500,
    };
    const ismultipackProductType = this.getmultipackProductType();
    const { errMsg } = addToBagMultipleItemError;
    const isOptimisticModalWithError = getIsOptimisticModalWithError(
      isOptmisticAddToBagModal,
      addedToBagError,
      errMsg,
      addToPickupError,
      newGlobalErrorMessageEnabled
    );

    const modalHeading = this.getModalHeading(isOptimisticModalWithError);
    const isNewErrorDesign = getIsNewErrorDesign(
      addedToBagError,
      errMsg,
      addToPickupError,
      newGlobalErrorMessageEnabled,
      isInventoryUnavailable
    );

    const offerPrice = getOfferPrice(addedToBagData);
    const { itemPrice, totalItems, bagSubTotal } = pointsSummary;
    const displayPrice = this.calculateItemPrice(itemPrice, offerPrice, isOptmisticAddToBagModal);
    const { isMobile } = getViewportInfo();
    const newArr = getNewArr(atbUnavailableProducts);
    const error = getError(atbUnavailableProducts);
    const { isExpanded } = this.state;
    const showInventoryUnavailableMessage = getShowInvUnavailableMsg(
      isInventoryUnavailable,
      addToPickupError,
      errMsg
    );
    const youMayAlsoLike = renderLabel(
      getLabelFromCopyOrFromTranslation(
        `${GLOBAL_RECOMMENDATIONS}.${lblHomepageYouMayAlsoLike}`,
        RecommendationLabels
      ),
      lblHomepageYouMayAlsoLike
    );
    return (
      openState && (
        <Modal
          fixedWidth
          isOpen={openState}
          onRequestClose={onRequestClose}
          heading={modalHeading}
          overlayClassName={`TCPModal__Overlay${
            isBackToQuickviewCTAEnabled && isQvModalOpen ? ' added-to-bag-modal-overlay' : ''
          }`}
          className={`TCPModal__Content, ${className}`}
          closeIconDataLocator="added-to-bg-close"
          aria={{
            labelledby: 'Added To Bag',
            describedby: 'Added To Bag Modal',
          }}
          data-locator="addedToBag-modal"
          inheritedStyles={modalStyles}
          innerContentClassName={`atb-innerContent${
            isBackToQuickviewCTAEnabled ? ' added-to-bag-modal-content-wrapper' : ''
          }`}
          isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
          isAddedToBagRedesignEnabled={isAddedToBagRedesignEnabled}
          isNewATBProductInformationDesignEnabled={isNewATBProductInformationDesignEnabled}
          isBackToQuickViewButtonShow={isBackToQuickviewCTAEnabled && isQvModalOpen}
          onAfterOpen={() => {
            if (isDyEnabled) {
              const payload = getATBContext({ data: [variantId] });
              loadDyRecommendations(payload);
            }
          }}
        >
          <div>
            {this.renderErrorMessage(isOptimisticModalWithError, isNewErrorDesign, errMsg)}
            {getIsShowErrorMessage(
              error,
              showInventoryUnavailableMessage,
              newGlobalErrorMessageEnabled
            ) && (
              <div className="new-error-container">
                <div className="new-error-inner-container">
                  {isInventoryUnavailable && newGlobalErrorMessageEnabled && (
                    <div className="error-header-arrow-container">
                      <BodyCopy
                        tag="span"
                        fontSize="fs13"
                        fontWeight="extrabold"
                        textAlign="left"
                        fontFamily="secondary"
                      >
                        {getDynamicLabelValues('dynamic.global_d.lbl_errorMessages_inventoryIssue')}
                      </BodyCopy>
                      <button className="toggle-arrow" onClick={this.toggleExpand}>
                        {this.getToggleImage()}
                      </button>
                    </div>
                  )}
                  <div
                    className={getErrorMessageClassName(
                      isInventoryUnavailable,
                      newGlobalErrorMessageEnabled,
                      isExpanded
                    )}
                  >
                    <BodyCopy
                      tag="span"
                      fontSize="fs12"
                      fontWeight={
                        isInventoryUnavailable && newGlobalErrorMessageEnabled ? 'medium' : 'bold'
                      }
                      textAlign="left"
                      fontFamily="secondary"
                      className="error-text-msg"
                    >
                      {getGlobalErrorMessageCopy(
                        isInventoryUnavailable,
                        newGlobalErrorMessageEnabled,
                        addToPickupError,
                        errMsg,
                        error
                      )}
                    </BodyCopy>
                  </div>
                  {newArr?.map((data) => {
                    const configData = getImageData(data.imageUrl);
                    return (
                      <DamImage
                        imgData={{
                          alt: 'Product',
                          url: data.imageUrl,
                        }}
                        imgConfigs={configData.imgConfig}
                        className="unavailable-product-image"
                        isProductImage
                      />
                    );
                  })}
                </div>
              </div>
            )}

            {this.renderSpinnerOverlay(addedToBagLoaderState)}
            {this.renderGhostOverlay(
              addedToBagGhostLoaderState,
              addedToBagGhostLoaderCompleteState,
              isFBTDisplayed
            )}
            <div
              className={`addedToBagWrapper ${this.getBluredClass()} ${this.getATBModalBackABClassClass()}`}
            >
              {this.renderProductDetails(
                displayPrice,
                totalItems,
                bagSubTotal,
                isOptimisticModalWithError
              )}
              <span className={`${this.getHideClass()}`}>
                {!isAddedToBagRedesignEnabled &&
                  shouldRenderPointsView(
                    pointsSummary,
                    isATBHidePoints,
                    isOptimisticModalWithError,
                    isOptmisticAddToBagModal,
                    isLoyaltyPointsEnabled
                  ) && (
                    <AddedToBagViewPoints
                      className="added-to-bag-points"
                      inheritedStyles={pointsInfoStyles}
                      isOptmisticAddToBagModal={isOptmisticAddToBagModal}
                      offerPrice={offerPrice}
                      isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
                      isAddedToBagRedesignEnabled={isAddedToBagRedesignEnabled}
                    />
                  )}
              </span>

              {isMobile &&
                this.getFreeShippingProgressBar({
                  shipments,
                  freeShippingThreshold,
                  productTotal,
                  dynamicShippingCharge,
                  isBossEnabled,
                  shippingMethodSelected,
                  isMixedOrder,
                  isFreeShippingProgressBarDisabled,
                  isShippingOrder,
                  isFreeShippingCouponApplied,
                  freeShippingMessageForPromosEnabled,
                  freeShippingPromoType,
                })}
              {!isAddedToBagRedesignEnabled && this.renderPickupBanner()}

              {!(isAddedToBagRedesignEnabled && isMobile) && (
                <AddedToBagActions
                  onRequestClose={onRequestClose}
                  handleCartCheckout={handleCartCheckout}
                  showVenmo={false}
                  containerId="paypal-button-container-added-to-bag"
                  inheritedStyles={buttonActionStyles}
                  hideHeader={hideHeader}
                  handleContinueShopping={handleContinueShopping}
                  enableKeepShoppingCTA={enableKeepShoppingCTA}
                  isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
                  isAddedToBagRedesign={isAddedToBagRedesignEnabled}
                  isAddedToBag
                />
              )}
              {isBundleTrackerEnabled && (
                <BundleTrackerContainer isCarousel onRequestClose={onRequestClose} />
              )}
              {isAddedToBagRedesignEnabled && this.renderPickupBanner()}
              {isAddedToBagRedesignEnabled && this.renderBossBanner()}
              {!isAddedToBagRedesignEnabled && this.renderBossBanner()}
              {isFBTEnabled && !isDyEnabled && (
                <div
                  className={`recommendationWrapper ${this.getFbtClass(
                    isFBTDisplayed
                  )}   ${this.getFbtWrapperClass(isFbtCompleted)}`}
                >
                  <Recommendations
                    page={Constants.RECOMMENDATIONS_PAGES_MAPPING.ADDED_TO_BAG}
                    variations={this.getVariations()}
                    styleHeaderLabel={this.getHeaderLabel()}
                    headerLabel={renderLabel(
                      this.addedToBagLabels?.lbl_heading_fbt,
                      'lbl_heading_fbt'
                    )}
                    priceOnly
                    inheritedStyles={recommendationStyles}
                    carouselConfigProps={carouselProps}
                    sequence="1"
                    isAddedToBag
                    starRatingSize={{ small: 63, large: 60 }}
                    partNumber={partNumber}
                    showPeek={{ small: false, medium: false }}
                    styleWithView={ismultipackProductType && !isFBTEnabled}
                    addedToBagData={addedToBagData}
                    styleWithEligibility={ismultipackProductType}
                    portalValue="fbt"
                    isFBTEnabled={isFBTEnabled}
                    isOptimisticModalWithError={isOptimisticModalWithError}
                    isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
                    addedToBagGhostLoaderState={addedToBagGhostLoaderState}
                    isComplete={addedToBagGhostLoaderCompleteState}
                    isFBTDisplayed={isFBTDisplayed}
                  />
                </div>
              )}
              {isDyEnabled ? (
                <DyRecommendations
                  title={dyRecommendationTitle(atb1Rec?.title, youMayAlsoLike)}
                  data={atb1Rec?.data}
                  page={dyPageNames.ATB}
                  isAddedToBag
                  inheritedStyles={recommendationStyles}
                  recommendationSelector={dySelectors.added_to_bag1}
                />
              ) : (
                <AiRecommendations
                  pageName={Constants.RECOMMENDATIONS_PAGES_MAPPING.ADDED_TO_BAG}
                  strategy={EINSTEIN_RECOMMENDATION_STRATEGIES.SIMILAR_PRODUCTS}
                  productId={partNumber}
                  serverTime={serverTime}
                  headerLabel={youMayAlsoLike}
                  engine={RECOMMENDATION_ENGINES.EINSTEIN}
                />
              )}
              {!isDyEnabled && (
                <div
                  className={`recommendationWrapper ${this.getRecommClass(
                    isAddedToBagRedesignEnabled
                  )}`}
                >
                  <Recommendations
                    page={Constants.RECOMMENDATIONS_PAGES_MAPPING.ADDED_TO_BAG}
                    variations={this.getVariations()}
                    priceOnly
                    inheritedStyles={recommendationStyles}
                    carouselConfigProps={carouselProps}
                    sequence="1"
                    isAddedToBag
                    starRatingSize={{ small: 63, large: 60 }}
                    partNumber={partNumber}
                    showPeek={{ small: false, medium: false }}
                    addedToBagData={addedToBagData}
                    styleWithEligibility={ismultipackProductType}
                    portalValue=""
                    isFBTEnabled={isFBTEnabled}
                    isOptimisticModalWithError={isOptimisticModalWithError}
                    isAddedToBagRedesign={isAddedToBagRedesignEnabled}
                    recommendationCarouselRedesign
                  />
                </div>
              )}
            </div>

            {isAddedToBagRedesignEnabled && isMobile && (
              <div className="elem-mb-SM">
                <AddedToBagActions
                  onRequestClose={onRequestClose}
                  handleCartCheckout={handleCartCheckout}
                  showVenmo={false}
                  containerId="paypal-button-container-added-to-bag"
                  inheritedStyles={buttonActionStyles}
                  hideHeader={hideHeader}
                  handleContinueShopping={handleContinueShopping}
                  enableKeepShoppingCTA={enableKeepShoppingCTA}
                  isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
                  isAddedToBagRedesign={isAddedToBagRedesignEnabled}
                  isAddedToBag
                />
              </div>
            )}
          </div>
        </Modal>
      )
    );
  }
}

AddedToBag.propTypes = {
  openState: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  addedToBagData: PropTypes.shape({}).isRequired,
  router: PropTypes.shape({}).isRequired,
  quantity: PropTypes.number.isRequired,
  handleContinueShopping: PropTypes.func.isRequired,
  isInternationalShipping: PropTypes.bool.isRequired,
  hideHeader: PropTypes.bool.isRequired,
  handleCartCheckout: PropTypes.func.isRequired,
  addedToBagLoaderState: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  pointsSummary: PropTypes.shape({}).isRequired,
  bagLoading: PropTypes.bool.isRequired,
  isBossEnabled: PropTypes.bool.isRequired,
  isSuppressGetOrderDetails: PropTypes.bool,
  isAvoidGetOrderDetails: PropTypes.bool,
  enableKeepShoppingCTA: PropTypes.bool,
  isABTestOffStyleWith: PropTypes.bool,
  isPhysicalMpackEnabled: PropTypes.bool,
  addedToBagGhostLoaderState: PropTypes.bool,
  addedToBagGhostLoaderCompleteState: PropTypes.bool,
  getBopisInventoryDetails: PropTypes.func,
  userDefaultStore: PropTypes.shape({}),
  bopisItemInventory: PropTypes.shape({}),
  pageType: PropTypes.shape({}),
  addItemToCartInPickup: PropTypes.func,
  addToPickupError: PropTypes.string,
  setAddToPickupError: PropTypes.func,
  showBOPISPickupInstead: PropTypes.bool,
  isATBHidePoints: PropTypes.bool,
  getFavoriteStore: PropTypes.func,
  addedToBagError: PropTypes.string,
  isOptmisticAddToBagModal: PropTypes.bool,
  isATBModalBackAbTestNewDesign: PropTypes.bool,
  clearSelectedAccessories: PropTypes.func,
  isLoyaltyPointsEnabled: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  isHardcodeSizeMapEnabled: PropTypes.bool,
  hardcodeSizeMapConfig: PropTypes.shape({}),
  isQvModalOpen: PropTypes.bool,
  closeQvModal: PropTypes.func,
  loyaltyOrderItemPoints: PropTypes.shape({}),
  isLoyaltyTieringEnabled: PropTypes.bool,
};

AddedToBag.defaultProps = {
  isSuppressGetOrderDetails: false,
  isAvoidGetOrderDetails: false,
  enableKeepShoppingCTA: false,
  isABTestOffStyleWith: false,
  isPhysicalMpackEnabled: false,
  addedToBagGhostLoaderState: false,
  addedToBagGhostLoaderCompleteState: false,
  getBopisInventoryDetails: () => {},
  userDefaultStore: {},
  bopisItemInventory: {},
  pageType: {},
  addItemToCartInPickup: () => {},
  addToPickupError: '',
  setAddToPickupError: () => {},
  showBOPISPickupInstead: false,
  isATBHidePoints: false,
  getFavoriteStore: () => {},
  addedToBagError: '',
  isOptmisticAddToBagModal: true,
  isATBModalBackAbTestNewDesign: false,
  clearSelectedAccessories: () => {},
  isLoyaltyPointsEnabled: false,
  isUserLoggedIn: false,
  isHardcodeSizeMapEnabled: false,
  hardcodeSizeMapConfig: {},
  isQvModalOpen: true,
  closeQvModal: () => {},
  loyaltyOrderItemPoints: {},
  isLoyaltyTieringEnabled: false,
};

export default withStyles(AddedToBag, styles);
export { AddedToBag as AddedToBagVanilla };
